// The bundle discount Shopify applies when a cart holds two or more distinct
// products.
export const BUNDLE_DISCOUNT_PERCENT = 25;

// The cart allocation title Shopify reports for that discount. It mirrors the
// `message` in shopify-checkout-apps' bundle-discount-function, not the admin
// discount name, so keep the two in sync.
export const BUNDLE_DISCOUNT_ALLOCATION_TITLE = '25% OFF FIRST ORDER';
